module.exports = {"id":"207858","name":"Dom Dwyer","rating":"72","photo":"./data/images/photos/4/207858.png","club":{"name":"Orlando City","logo":"./data/images/clubs/OrlandoCity.png"},"positions":["BU"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DomDwyer0.json
// module id = 1126
// module chunks = 0